module.exports = __webpack_public_path__ + "img/wide.3193b8d1.jpg";